import { Progress } from '@mantine/core'
import { FmtColored, useFmtColor } from '../../widgets/format'
import { Typography } from '../../common/typography'
import classes from './StatRow.module.css'

export default function StatRow({
  title,
  value,
  metric,
}: {
  title: string
  value: number | null | undefined
  metric?: string | number
}) {
  metric = metric || ''
  const color = useFmtColor({
    metric,
    value,
    component: 'percent',
    statistic: 'value',
  })

  return (
    <div className={classes.container}>
      <Typography fc={{ light: 'black', dark: 'gray-2' }} lh="110">
        {title}
      </Typography>
      <Progress color={color} value={(value || 0) * 100} />
      <FmtColored
        value={value}
        metric={metric}
        component="percent"
        statistic="value"
        override={{ percent_decimal_places: 1 }}
        className={classes.alignRight}
      />
    </div>
  )
}
